export default __webpack_public_path__ + "static/media/1886.72e3c38d.png";